module.exports = __webpack_public_path__ + "static/media/pancreta.5a9049d3.png";